import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
// import images from '../../ressources/images'

import "./InsHeaderFormationsIndex.scss";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import images from "../../ressources/images";

class InsHeaderFormationsIndex extends Component {
  static propTypes = {
    linkBack: PropTypes.string,
    state: PropTypes.any,
  };
  static defaultProps = {
    linkBack: "/formations/",
  };

  /**
   * Retour à la page précédente
   */
  _goBack = () => {
    const { history } = this.props;

    const prev = localStorage.getItem("go-back-page");

    if (prev) {
      history.push(prev);
    } else {
      history.push("/");
    }
  };

  render() {
    const { addLike, isLiked, likes } = this.props;
    return (
      <Fragment>
        <header className="header_formationsIndex">
          <div className="back_link_formationsIndex" onClick={this._goBack}>
            <img src={images.arrow_left_white} alt="" />
          </div>
          <div className="formation_likes">
            <div
              className={isLiked ? "like_icon liked" : "like_icon"}
              onClick={addLike}
            ></div>
            <div className="like_count">{likes}</div>
          </div>
        </header>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  navigation: state.navigation,
});

export default withRouter(connect(mapStateToProps)(InsHeaderFormationsIndex));
